// extracted by mini-css-extract-plugin
export default {"details":"fire-dispatch-details_details__oPq0c"};